"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueNodeKeySet = void 0;
/**
 * Tracks which unique nodes have been seen before.
 * Uses precalculated DedupedNode.fingerprints property to determine uniqueness.
 * DedupedNode.fingerprints is a string[] of stringified target, xpath, and ancestry.
 */
class UniqueNodeKeySet {
    #fingerprints = new Map();
    getDuplicateFingerprint = (node) => {
        // For the case of Mobile, there are no fingerprints generated
        // TODO: https://github.com/dequelabs/jazzband/issues/2359
        if (!node.fingerprints) {
            return;
        }
        const duplicateFingerprint = node.fingerprints.find(fingerprint => this.#fingerprints.has(fingerprint));
        return duplicateFingerprint
            ? this.#fingerprints.get(duplicateFingerprint)
            : undefined;
    };
    upsert = (node) => {
        // For the case of Mobile, there are no fingerprints generated
        // TODO: https://github.com/dequelabs/jazzband/issues/2359
        if (!node.fingerprints) {
            return;
        }
        // This will always be the stringified target selector
        const primaryFingerprint = node.fingerprints[0];
        node.fingerprints.forEach(fingerprint => {
            this.#fingerprints.set(fingerprint, primaryFingerprint);
        });
    };
    static from(result) {
        const uniques = new UniqueNodeKeySet();
        for (const unique of result.uniques) {
            uniques.upsert(unique);
        }
        return uniques;
    }
}
exports.UniqueNodeKeySet = UniqueNodeKeySet;
//# sourceMappingURL=uniqueNodeKeySet.js.map